import classNames from 'classnames';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';
import { config, getAssetUrl } from '../../../../utils/config';
import { useFormName } from '../../../../utils/formName';
import Button from '../../../atoms/Button';
import EmailField from '../../../fields/EmailField';
import NamesField from '../../../fields/NamesField';
import SelectField from '../../../formik/SelectField';
import DynamicFieldArea from '../../DynamicFieldArea';
import './style.scss';

const Guest = () => {
  const { submitForm, isSubmitting, setFieldValue } = useFormikContext();
  const { formatMessage } = useIntl();
  const { isLoading } = useFormName();
  const testIdPrefix = 'guest';
  const { neutralGender } = config.features;

  return (
    <div className="option__form">
      <div className="form">
        <div className="form__row">
          <div className="form__field-container">
            <Field
              name="gender"
              component={SelectField}
              data-test-id="guest-gender"
              label={formatMessage({ id: 'generic.salutation.label' })}
              options={['f', 'm', ...(neutralGender.enabled ? ['d'] : [])].map(value => ({
                label: formatMessage({ id: `generic.salutation.options.${value}` }),
                value
              }))}
              autoComplete="sex"
            />
          </div>
        </div>
        <div className="form__row">
          <div className="form__field-container">
            <EmailField testIdPrefix={testIdPrefix} autocomplete="email" type="guest" />
          </div>
        </div>
        <div className="form__row form__row--names">
          <NamesField testIdPrefix={testIdPrefix} />
        </div>
        <DynamicFieldArea area="guest" />
        <div className="form__row">
          <div className="form__field-container">
            <Button
              type="submit"
              onClick={e => {
                if (!isLoading) {
                  e.preventDefault();
                  submitForm();
                }
              }}
              data-test-id="guest-continue-without-benefits"
              disabled={isSubmitting}
              className={classNames({ 'cursor-disabled': !!isLoading })}
              isLoading={isSubmitting}
            >
              <FormattedMessage id="auth.options.guest.submit" />
            </Button>
          </div>
        </div>
        <div className="auth-step-options__divider">
          <span className="auth-step-options__divider-line auth-step-options__divider-line--left"></span>
          <FormattedMessage id="auth.options.guest.benefits.label" />
          <span className="auth-step-options__divider-line auth-step-options__divider-line--right"></span>
        </div>
        <div className="form__row">
          <div className="missing-features">
            {['track', 'follow', 'filter'].map(key => (
              <div className="missing-features__feature" key={key}>
                <img src={getAssetUrl(`benefits/${key}.svg`)} />
                <span>
                  <FormattedMessage id={`auth.options.guest.benefits.${key}`} />
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="form__row">
          <div className="form__field-container">
            <Button
              type="button"
              secondary
              onClick={() => setFieldValue('type', 'register')}
              data-test-id="create-account"
            >
              <FormattedMessage id="auth.options.guest.benefits.register" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guest;
